"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/babel-runtime/6.18.0/babel-runtime/helpers/classCallCheck.js
// module id = 116
// module chunks = 0